import { fromEvent } from "rxjs";
import { pluck } from "rxjs/operators";
import { FormFieldComponent } from "../formFieldComponent";
import { Form } from "../form";
import { IMessagingService } from "../../services";

class CheckboxComponent extends FormFieldComponent {

    private inputEl: HTMLInputElement;

    constructor(protected fieldEl: HTMLElement, messagingService: IMessagingService, protected form: Form) {
        super(fieldEl, messagingService, form);

        
        this.inputEl = fieldEl.querySelector<HTMLInputElement>(".js-checkbox");

        // listen for the field changing, and extract its value
        const onCheckboxClicked$ = fromEvent(this.inputEl, "change").pipe(
            pluck("target", "checked")
        );

        // when the form value changes, and update the value in the store
        onCheckboxClicked$.subscribe((value: boolean) => {
            super.setResponseValue(value);
        });
    }

    // update the value of this field in the DOM.
    protected setDisplayValue(value: boolean) {
        if(value) {
            this.inputEl.checked = value;
        }
    }
    
    public setFocus() {
        this.inputEl.focus();
    }
};

export { CheckboxComponent  };